/**
 * The level curve, for the browser.
 *
 * The server's is in `models/MemberLevel.ts`, which the client bundle must not
 * import (it drags Mongoose in). The two are held equal by
 * `level-curve.test.ts`, so a change to one that forgets the other fails.
 */
export function xpForNextLevel(level: number): number {
  return 5 * level * level + 50 * level + 100;
}

/** Total XP to reach `level` from zero — the figure a reward is earned at. */
export function totalXpForLevel(level: number): number {
  let total = 0;
  for (let step = 0; step < Math.min(level, 1000); step++) total += xpForNextLevel(step);
  return total;
}
